module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2.c607a6fe.png";